/*
 * Lumao — poptávkový / objednávkový formulář
 * ---------------------------------------------------------------
 * Nahrazuje dřívější self-checkout s živým AI náhledem. Zákazník vyplní
 * kontakt + text na lampičku, nahraje fotku a odešle. My se mu pak ozveme.
 *
 * Odeslání jede přes VESTAVĚNÝ Shopify kontaktní formulář ({% form 'contact' %}):
 *   1) fotku nahrajeme na Cloudinary HNED po výběru souboru (ne až na submit),
 *   2) odkaz na fotku vložíme do skrytého pole contact[Foto],
 *   3) na odeslání už jen necháme formulář ODESLAT NATIVNĚ.
 *
 * !!! DŮLEŽITÉ: na tomto obchodu je u kontaktního formuláře zapnutá Shopify
 * CAPTCHA. Shopify vkládá captcha token přes posluchač na 'submit' UDÁLOSTI.
 * Kdybychom volali form.submit() ručně, událost se PŘESKOČÍ → „Missing CAPTCHA
 * token" → 400. Proto fotku nahráváme předem a submit necháme proběhnout
 * nativně (jen ho zablokujeme, dokud nejsou data validní). Nikdy nevolat
 * formEl.submit() / requestSubmit() ručně.
 *
 * Bez vyplněného kontaktu, souhlasu a (když je povinná) nahrané fotky nejde odeslat.
 */

/* Localisation bridge: strings come from snippets/lumao-i18n.liquid, which runs
   as a blocking inline script in <head> and is therefore always set before this
   deferred asset executes. The second argument is a last-resort fallback. */
function lumaoT(key, fallback) {
  var table = (typeof window !== 'undefined' && window.lumaoI18n) || {};
  return table[key] || fallback;
}
if (!customElements.get('lumao-inquiry')) {
  customElements.define(
    'lumao-inquiry',
    class LumaoInquiry extends HTMLElement {
      connectedCallback() {
        if (this._init) return;
        this._init = true;

        this.cloud = this.dataset.cloud || '';
        this.preset = this.dataset.preset || '';
        this.requirePhoto = this.dataset.requirePhoto === 'true';
        this.maxBytes = (parseFloat(this.dataset.maxMb) || 25) * 1024 * 1024;

        this.formEl = this.closest('form');

        this.nameInput = this.querySelector('[data-name]');
        this.emailInput = this.querySelector('[data-email]');
        this.phoneInput = this.querySelector('[data-phone]');

        this.fileInput = this.querySelector('[data-file]');
        this.drop = this.querySelector('[data-drop]');
        this.dropText = this.querySelector('[data-droptext]');
        this.thumb = this.querySelector('[data-thumb]');
        this.fotoInput = this.querySelector('[data-foto]');

        this.status = this.querySelector('[data-status]');
        this.consent = this.querySelector('[data-consent]');
        this.submit = this.querySelector('[data-submit]');

        this.file = null;
        this.photoReady = false;
        this.uploading = false;

        this.bindEvents();
        this.updateSubmit();
      }

      bindEvents() {
        [this.nameInput, this.emailInput, this.phoneInput].forEach((el) => {
          if (el) el.addEventListener('input', () => this.updateSubmit());
        });
        if (this.consent) this.consent.addEventListener('change', () => this.updateSubmit());

        if (this.fileInput) {
          this.fileInput.addEventListener('change', (e) => this.onFile(e.target.files[0]));
        }
        if (this.drop) {
          ['dragover', 'dragenter'].forEach((ev) =>
            this.drop.addEventListener(ev, (e) => {
              e.preventDefault();
              this.drop.classList.add('is-over');
            })
          );
          ['dragleave', 'drop'].forEach((ev) =>
            this.drop.addEventListener(ev, (e) => {
              e.preventDefault();
              this.drop.classList.remove('is-over');
            })
          );
          this.drop.addEventListener('drop', (e) => {
            const f = e.dataTransfer && e.dataTransfer.files[0];
            if (f) this.onFile(f);
          });
          this.drop.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.fileInput.click();
            }
          });
        }

        // Nativní submit necháme proběhnout (kvůli Shopify captcha), jen ho
        // zablokujeme, dokud nejsou data validní / fotka nahraná.
        if (this.formEl) this.formEl.addEventListener('submit', (e) => this.onSubmit(e));
      }

      onFile(file) {
        if (!file) return;
        if (!['image/jpeg', 'image/png', 'image/webp', 'image/heic'].includes(file.type)) {
          this.setStatus(lumaoT('formatError', 'Nepodporovaný formát. Použij JPG, PNG nebo WEBP.'), 'err');
          return;
        }
        if (file.size > this.maxBytes) {
          this.setStatus(lumaoT('tooLarge', 'Fotka je moc velká (max 25 MB).'), 'err');
          return;
        }
        this.file = file;
        this.classList.add('has-photo');
        if (this.thumb) {
          this.thumb.src = URL.createObjectURL(file);
          this.thumb.hidden = false;
        }
        if (this.dropText) this.dropText.textContent = lumaoT('changePhoto', 'Změnit fotku');
        this.uploadPhoto();
      }

      async uploadPhoto() {
        if (!this.file) return;
        if (!this.cloud || !this.preset) {
          this.setStatus(lumaoT('inquiryStorageMissing', 'Úložiště fotek není nastavené. Napiš nám prosím na lampickyprotebe@gmail.com.'), 'err');
          return;
        }
        this.uploading = true;
        this.photoReady = false;
        if (this.fotoInput) this.fotoInput.value = '';
        this.setStatus(lumaoT('uploading', 'Nahrávám fotku…'), 'load');
        this.updateSubmit();

        try {
          const blob = await this.downscale(this.file);
          const safe = ((this.nameInput && this.nameInput.value.trim()) || 'zakaznik')
            .replace(/[^a-zA-Z0-9_-]+/g, '-')
            .slice(0, 30) || 'zakaznik';
          const filename = 'poptavka-' + safe + '-' + Date.now() + '.jpg';
          let up = await this.cloudinaryUpload(blob, filename, true);
          if (!up) up = await this.cloudinaryUpload(blob, filename, false);
          if (!up || !up.secure_url) throw new Error('Cloudinary: chybí secure_url');
          if (this.fotoInput) this.fotoInput.value = up.secure_url;
          this.photoReady = true;
          this.uploading = false;
          this.setStatus(lumaoT('inquiryUploadOk', 'Fotka nahraná.'), 'ok');
        } catch (err) {
          console.error('Lumao inquiry: nahrání fotky selhalo', err);
          this.uploading = false;
          this.photoReady = false;
          this.setStatus(lumaoT('inquiryUploadFailed', 'Nahrání fotky se nepovedlo. Zkus to prosím znovu (klikni na fotku a vyber ji).'), 'err');
        }
        this.updateSubmit();
      }

      validEmail(v) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((v || '').trim());
      }

      updateSubmit() {
        const hasName = !!(this.nameInput && this.nameInput.value.trim());
        const hasEmail = this.validEmail(this.emailInput && this.emailInput.value);
        const hasPhone = !this.phoneInput || !!this.phoneInput.value.trim();
        const hasConsent = !this.consent || this.consent.checked;
        const photoOk = !this.requirePhoto || this.photoReady;
        const ok = hasName && hasEmail && hasPhone && hasConsent && photoOk && !this.uploading;
        if (this.submit) {
          this.submit.disabled = !ok;
          this.submit.setAttribute('aria-disabled', ok ? 'false' : 'true');
        }
      }

      onSubmit(e) {
        const name = (this.nameInput && this.nameInput.value.trim()) || '';
        if (!name || !this.validEmail(this.emailInput && this.emailInput.value)) {
          e.preventDefault();
          this.setStatus(lumaoT('inquiryValidationName', 'Doplň prosím jméno a platný e-mail.'), 'err');
          return;
        }
        if (this.phoneInput && !this.phoneInput.value.trim()) {
          e.preventDefault();
          this.setStatus(lumaoT('inquiryValidationPhone', 'Doplň prosím telefon.'), 'err');
          return;
        }
        if (this.uploading) {
          e.preventDefault();
          this.setStatus(lumaoT('inquiryWaitUpload', 'Počkej chvilku, ještě nahrávám fotku…'), 'load');
          return;
        }
        if (this.requirePhoto && !this.photoReady) {
          e.preventDefault();
          this.setStatus(lumaoT('needPhoto', 'Nahraj prosím fotku.'), 'err');
          return;
        }
        if (this.consent && !this.consent.checked) {
          e.preventDefault();
          this.setStatus(lumaoT('inquiryValidationConsent', 'Potvrď prosím souhlas se zpracováním údajů.'), 'err');
          return;
        }
        // bez fotky (když není povinná) doplň lidsky čitelný příznak
        if (!this.photoReady && this.fotoInput && !this.fotoInput.value) {
          this.fotoInput.value = lumaoT('inquiryNoPhoto', 'Zákazník fotku nepřiložil');
        }
        // NEvoláme preventDefault → formulář se odešle nativně (Shopify captcha
        // přidá token) a stránka se znovu načte s potvrzením.
        this.setStatus(lumaoT('inquirySending', 'Odesílám…'), 'load');
      }

      async cloudinaryUpload(blob, filename, withMeta) {
        const fd = new FormData();
        fd.append('file', blob, filename);
        fd.append('upload_preset', this.preset);
        if (withMeta) {
          fd.append('tags', 'poptavka');
          fd.append('context', 'zdroj=poptavka');
        }
        const res = await fetch(`https://api.cloudinary.com/v1_1/${this.cloud}/image/upload`, {
          method: 'POST',
          body: fd,
        });
        if (!res.ok) {
          if (withMeta) return null; // zkus znovu bez context/tags (některé presety je blokují)
          throw new Error('Cloudinary HTTP ' + res.status);
        }
        return res.json();
      }

      setStatus(msg, kind) {
        if (!this.status) return;
        this.status.textContent = msg;
        this.status.dataset.kind = kind || '';
      }

      downscale(file) {
        return new Promise((resolve) => {
          const MAX = 2400;
          const url = URL.createObjectURL(file);
          const im = new Image();
          im.onload = () => {
            const longest = Math.max(im.width, im.height);
            if (longest <= MAX && file.size <= 8 * 1024 * 1024) {
              URL.revokeObjectURL(url);
              resolve(file);
              return;
            }
            const scale = Math.min(1, MAX / longest);
            const c = document.createElement('canvas');
            c.width = Math.round(im.width * scale);
            c.height = Math.round(im.height * scale);
            c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
            c.toBlob(
              (b) => {
                URL.revokeObjectURL(url);
                resolve(b || file);
              },
              'image/jpeg',
              0.92
            );
          };
          im.onerror = () => {
            URL.revokeObjectURL(url);
            resolve(file);
          };
          im.src = url;
        });
      }
    }
  );
}
